<template>
  <div class="innerMongolia_directory">
      <div class="innerMogolia_directory_container main">
            <p class="discribe">
                本次培训面向内蒙古自治区中部四盟市，呼和浩特市（内蒙古师大附中）、包头市、乌兰察布市、锡林郭勒盟等地民族语言授课学校的统编三科教师。
                项目校名录如下：
            </p>
            <div class="table">
                <el-table
                :data="tableData"
                border
                style="width: 100%">
                    <el-table-column
                      prop="city"
                      label="市"
                      width="262"
                      align="center">
                    </el-table-column>
                    <el-table-column
                      prop="county"
                      label="区县"
                      width="345"
                      align="center">
                    </el-table-column>
                    <el-table-column
                      prop="school"
                      label="学校"
                      align="center">
                    </el-table-column>
                </el-table>
            </div>
        </div>
  </div>
</template>

<script>
import directory from "../../../config/utils/innerMongolia-directory";
export default {
    
    data() {
      return {
        tableData: directory
      }
    }
}
</script>

<style lang="less" scoped>
.innerMongolia_directory {
    .main {
        width: 1140px;
        margin: 0 auto;
        padding: 0 30px;
    }

    .discribe {
        margin-top: 80px;
        line-height: 36px;
        font-size: 17px;
        color: #484848;
        text-align: center;
    }

    .table {
        margin: 44px 0 272px;
    }

    /deep/ .el-table {
        border-radius: 5px;
    }

    /deep/ .el-table thead th{
        color: #fff;
        background-color: rgba(35, 115, 236, 0.76);
        border-right: 0px solid rgba(35, 115, 236, 0.76);
    }
}

</style>